import { FileText, MessageSquare, Sparkles } from 'lucide-react';

import type { TemplateAr } from '../../template-data';

export const automatePiiRedactionOnTicketsWithAiAr: TemplateAr = {
  name: 'أتمتة تنقيح بيانات PII في التذاكر بالذكاء الاصطناعي',
  description:
    'اكتشاف وتنقيح بيانات PII وPHI وPCI تلقائياً من التذاكر ونصوص المكالمات قبل خروجها من بيئتك — لأغراض الامتثال والتدقيق.',
  category: 'دعم العملاء',
  workflow: [
    { icon: MessageSquare, label: 'تذكرة' },
    { icon: Sparkles, label: 'الـ AI يكتشف' },
    { icon: FileText, label: 'تم التنقيح', final: true },
  ],
  detailDescription: {
    paragraph1:
      'محادثات عملائك مليئة بالبيانات الحساسة — أرقام بطاقات الائتمان، وأرقام الضمان الاجتماعي، وأرقام الحسابات، والمعلومات الصحية، والعناوين. الـ AI يكتشف حقول PII وPHI وPCI في التذاكر ونصوص المكالمات تلقائياً، وينقّحها قبل ما تنتقل البيانات لأنظمة التقارير أو التحليلات أو تدريب نماذج AI أو الأدوات الخارجية. وتغطي أدوات الكشف المدمجة جميع أنواع البيانات الخاضعة للتنظيم منذ اللحظة الأولى، مع إمكانية تهيئة أدوات كشف مخصصة لكل منشأة.',
    paragraph2:
      'التنقيح قابل للعكس داخل بيئتك لموظفي الدعم اللي يحتاجون البيانات لأسباب مشروعة، وغير قابل للعكس في كل ما يليها من أنظمة. وتوضّح تقارير الامتثال وش تم تنقيحه، ووين، وليش. ويشتغل على جميع أنظمة الدعم الرئيسية (Zendesk وHubSpot وIntercom وFreshdesk وSalesforce) وجميع نصوص المكالمات الصوتية، الواردة والصادرة. وهو متوافق مع HIPAA وGDPR وPCI افتراضياً، وقابل للتهيئة لبرامج SOC 2 وSOX.',
  },
  benefits: [
    'الـ AI يكتشف PII وPHI وPCI لحظياً',
    'البيانات المنقّحة ما توصل للتقارير ولا التحليلات ولا الأطراف الخارجية',
    'قابل للعكس داخل بيئتك لاحتياجات الدعم المشروعة',
    'تهيّئ أدوات كشف مخصصة لكل منشأة عندك',
    'متوافق مع HIPAA وGDPR وPCI افتراضياً',
    'تقارير تدقيق امتثال بسلسلة تنقيح كاملة',
  ],
};
